export enum StockStatus {
  lowStock = 'lowStock',
  outOfStock = 'outOfStock',
  noStock = 'noStock',
  unavailable = 'unavailable',
  inStock = 'inStock'
}
